import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme =>
  createStyles({
    description: {
      backgroundColor: theme.palette.common.gray100,
      display: 'flex',
      gap: theme.spacing(2),
      flexDirection: 'column',
      padding: theme.spacing(2),
      borderRadius: theme.misc.borderRadius,
    },
    noticeText: {
      color: '#888888',
      fontSize: '14px',
      '& a:link': {
        color: '#888888',
      },
    },
    columnLayout: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),
    },
    requiredLabel: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    desktopBorder: {
      [theme.breakpoints.up('md')]: {
        border: theme.customBorders.gray300,
        padding: theme.spacing(3),
        borderRadius: theme.misc.borderRadius,
      },
    },
    desktopSmallerButton: {
      [theme.breakpoints.up('md')]: {
        alignSelf: 'flex-start',
      },
    },
  }),
);
